<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <base-button-item-list v-if="!isRoleUserOrConsulta" theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" :ariaHidden="true"/>
              Desvincular
          </base-button-item-list>
        </template>
      </base-table-select-actions>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="!isRoleUserOrConsulta" mode="primary" :text="$t('certificates.link_company')" icon="link" @click="golinkCompany" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <certificate-link-company-dialog v-if="!isRoleUserOrConsulta" :dialogOpen="linkCompany" :certificate="this.$route.params.id" @toggleDialog="toggleDialogs" @applyDialog="applyLinkHandler" />

      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/CertCompaniesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getCompanies } from '@/services/companies/getCompanies'
import { getCertificate } from '@/services/certificates/getCertificate'
import { linkCertificate } from '@/services/certificates/linkCertificate'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import CertificateLinkCompanyDialog from '@/components/CertificateLinkCompanyDialog.vue'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import { unlinkCertificate } from '@/services/certificates/unlinkCertificate'
import { downloadExcel } from '@/services/companies/downloadExcel'

export default {
  name: 'list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    CertificateLinkCompanyDialog
  },
  data: function () {
    return {
      idVista: 7,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      linkCompany: false,
      spanish: true,
      header: {
        title: i18n.t('app.companies_link'),
        icon: 'certificates',
        breadcrumb: null,
        url: 'certificates/detail'
      },
      vuexnamespace: 'certcompanies',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    allCifs: function () {
      // this.$store.getters['app/allCifs'].forEach(row => {
      //   this.links.push({ id: row.IdCIFEmpresa, value: row.CIF })
      // })
      return this.$store.getters['app/allCifs']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
    // this.kendo.columns.shift()
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    const idEmpresa = this.$route.params.idEmpresa
    const serial = this.$route.params.serial
    const tipoCertificado = this.$route.params.tipo
    const params = {
      idEmpresa,
      serial,
      tipoCertificado
    }
    const breadcrumbs = []
    breadcrumbs.push({ path: 'certificates', name: this.$i18n.t('app.certificates') })
    if (this.$store.getters['app/fromRouteName'] !== null) {
      const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
      breadcrumbs.push({ path: '', name: breadcrumbHeader })
    } else {
      const certificate = await this.downloadData(params)
      breadcrumbs.push({ path: '', name: certificate.Certificado.CommonName })
      this.$store.commit('app/setheaderBreadCrumb', certificate.Certificado.CommonName)
    }
    this.header.breadcrumb = breadcrumbs

    this.data = await this.applyFilters()
  },
  methods: {
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      // console.log('Ir a registro con ID: ', event.dataItem.id)
      // this.$router.push({ name: 'companies/detail', params: { id: event.dataItem.id } })
    },
    setWhatShow: function () {
      this.showAllRows = !this.showAllRows
    },
    tableSelected: function (val) {
      this.selected = val
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkCompany = !this.linkCompany
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        SerialNumber: this.$route.params.serial,
        idEmpresa: this.$route.params.idEmpresa,
        tipoCertificado: this.$route.params.tipo,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        descargaAutomatica: data.automatic_download ? data.automatic_download.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        estado: data.estado ? data.estado.value : null,
        emailGenerico: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        codigoSede: data.codPGN ? data.codPGN.value : null,
        conPoderesDelegados: data.conPoderesDelegados ? data.conPoderesDelegados.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdCIFEmpresa)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await downloadExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'certificado-empresas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        SerialNumber: this.$route.params.serial,
        idEmpresa: this.$route.params.idEmpresa,
        tipoCertificado: this.$route.params.tipo,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        descargaAutomatica: data.automatic_download ? data.automatic_download.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        estado: data.estado ? data.estado.value : null,
        emailGenerico: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        codigoSede: data.codPGN ? data.codPGN.value : null,
        conPoderesDelegados: data.conPoderesDelegados ? data.conPoderesDelegados.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        this.data = data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general ' + error))
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      this.updateAllSelectedHeader()
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getCompanies(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      data.respuesta.forEach(o => {
        o.DiasDescargaAutomatica = o.DiasDescargaAutomatica === null ? 0 : o.DiasDescargaAutomatica
        o.DiasAviso = o.DiasAviso === null ? 'Desactivado' : o.DiasAviso
        o.DiasFinTramite = o.DiasFinTramite === null ? 'Desactivado' : o.DiasFinTramite
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const data = await getCertificate(id)
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          return data
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return []
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      // for await (const element of selected) {
      //   await this.unlinkHandler(element.IdCIFEmpresa)
      // }
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (companies) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idCIFS: [],
          serialCert: this.$route.params.serial,
          tipoCertificado: this.$route.params.tipo,
          idEmpresa: this.$route.params.idEmpresa
        }
        companies.forEach(element => {
          payload.idCIFS.push(element.IdCIFEmpresa)
        })
        const response = await unlinkCertificate(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Desvinculado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkCompany: function () {
      this.linkCompany = !this.linkCompany
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    applyLinkHandler: async function (companies) {
      this.linkCompany = false
      // console.log('applyLinkHandler', companies)
      await this.linkHandler(companies)
      this.applyFilters()
    },
    linkHandler: async function (companies) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCIFS: companies[0],
          serialCert: this.$route.params.serial,
          tipoCertificado: this.$route.params.tipo,
          idEmpresa: this.$route.params.idEmpresa
        }
        const response = await linkCertificate(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
